import React from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { ResponsiveImage } from '@web/molecules';
import { Heading, PillText } from '@web/atoms';
import { useShopifyOfferContext } from '../../offer/shopifyContext';
import {
  CardContainer,
  ImageWrapper,
  ContentWrapper,
  NumberCircle,
  TitleWrapper,
  BodyWrapper,
  BadgeContainer,
} from './styles';

export const SimpleCalloutCard = ({
  image,
  heading,
  body,
  badge,
  badgeVariant = 'dark',
  badgeIcon,
  badgeIconAlignment = 'left',
  headingLevel = 'h3',
  typography = 'heading6',
  icon,
  align,
  backgroundColor = 'background.base',
  contentAlignment = 'flex-start',
}) => {
  const { formattedAmount } = useShopifyOfferContext();
  return (
    <CardContainer $align={align}>
      {badge && (
        <BadgeContainer>
          <PillText
            text={interpolate(badge, { offer: formattedAmount ?? '50%' })}
            variant={badgeVariant}
            icon={badgeIcon}
            iconAlignment={badgeIconAlignment}
          ></PillText>
        </BadgeContainer>
      )}

      <ImageWrapper>
        <ResponsiveImage {...image} />
      </ImageWrapper>
      <ContentWrapper $contentAlignment={contentAlignment}>
        <TitleWrapper>
          {icon && (
            <NumberCircle>
              <ResponsiveImage {...icon} />
            </NumberCircle>
          )}
          <Heading
            headingLevel={headingLevel}
            typography={typography}
            headingText={interpolate(heading, {
              offer: formattedAmount ?? '50%',
            })}
            position="center"
            backgroundColor={backgroundColor}
          />
        </TitleWrapper>
        {body && (
          <BodyWrapper>
            {interpolate(body, { offer: formattedAmount })}
          </BodyWrapper>
        )}
      </ContentWrapper>
    </CardContainer>
  );
};

SimpleCalloutCard.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string,
  headingLevel: PropTypes.string,
  typography: PropTypes.string,
  badgeVariant: PropTypes.string,
  badgeIcon: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  badgeIconAlignment: PropTypes.oneOf(['left', 'right']),
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  align: PropTypes.string,
  backgroundColor: PropTypes.string,
};
